import UserContext, { UserContextState } from "@src/lib/contexts/UserContext";
import { useContext, useMemo } from "react";

const useUser = (): UserContextState => {
  const { user, isStaff } = useContext(UserContext);
  return useMemo(() => ({ user, isStaff }), [user, isStaff]);
};

export default useUser;
